import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { BiUpArrowAlt } from "react-icons/bi";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/Stock.css";
import CountStockIcon from "../../assets/icons/CountStock.svg";
import settingsIcon from "../../assets/icons/settingsIcon.svg";
import OrderPickingIcon from "../../assets/icons/OrderPicking.svg";
import OrderPickingInIcon from "../../assets/icons/OrderPickingIn.svg";
import OrderPickingOutIcon from "../../assets/icons/OrderPickingOut.svg";
import ProductIcon from "../../assets/icons/Product.svg";
import ShoppingCartIcon from "../../assets/icons/ShoppingCart.svg";
import clock from "../../assets/icons/clock.svg";
import pin from "../../assets/icons/pin.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import SupplierIcon from "../../assets/icons/Suppliers.svg";
import WarehouseIcon from "../../assets/icons/Warehouse.svg";
import calender from "../../assets/images/Calendar4.svg";
import pdfIcon from "../../assets/images/PdfIcon.svg";
import Header from "../../layouts/Header";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import xIcon from "../../assets/icons/x-circle-white.svg";
import TotalStockAvailableCard from "../../components/Stock_Management/TotalStockAvailableCard";
import AdvisedItemPurchaseCard from "../../components/Stock_Management/AdvisedItemPurchaseCard";
import JustIntimePurchaseCard from "../../components/Stock_Management/JustInTimePurchaseCard";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

import { ROLES, isNotRole, isRole } from "../../utils/helpers/userRole";

import moment from "moment";
import {
  FetchPurchasingOrderAwaiting,
  ApproveOrder,
  generateAdvicedPurchaseOrder,
  fetchTranslationData,
  TotalStockAvailable,
  AdvicedItemPurchaseData,
} from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import AddPurchasingOrderModal from "../../components/Dailogs/AddPurchasingOrderModal";
import grapesTemplateApi from "../../services/grapesTemplateApi";
import Loader from "../../components/Dailogs/Loader";

const Stock = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const ViewBy_Popup_Ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showFilterDrop, setShowFilterDrop] = useState(false);
  const [showOrderBy, setShowOrderBy] = useState(true);
  const [stockLevel, setStockLevel] = useState(false);
  const [filterVal, setFilterVal] = useState("Order ID");
  const [stockData, setStockData] = useState([]);
  const [advicedPurchaseData, setAdvicedPurchaseData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [approvedData, setApprovedData] = useState([]);

  const roleid = window.localStorage.getItem("roleid");
  const packageId = window.localStorage.getItem("packageId");
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";

  const isOwnerOrManagerOrUser =
    isRole(ROLES.OWNER) || isRole(ROLES.MANAGER) || isRole(ROLES.USER);

  const fetchTotalStockData = useSelector(
    (state) => state.user.totalStockAvailable,
  );

  const puchasingAdviceData = useSelector(
    (state) => state.user.advicedItemPurchase,
  );

  const fetchPurchasingOrderAwaitingData = useSelector(
    (state) => state.user.fetchPurchasingOrderAwaiting,
  );

  const approvedOrderRes = useSelector((state) => state.user.approvedOrderRes);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const isOpenStockLevel = localStorage.getItem("openStockLevels");
  useEffect(() => {
    if (isOpenStockLevel === "true") {
      setStockLevel(true);
    }
  }, [isOpenStockLevel]);

  useEffect(() => {
    if (!stockLevel) {
      localStorage.removeItem("openStockLevels");
    }
  }, [stockLevel]);

  useEffect(() => {
    dispatch(TotalStockAvailable());
    dispatch(AdvicedItemPurchaseData());
    fetchScreenTranslations("Stock Overview").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const screenSize = useScreenSize();

  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const [isEssentialPlus, setIsEssentialPlus] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const isPlus = useMemo(() => {
    return window.localStorage.getItem("hasPlus") == "true";
  }, []);

  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
      setIsEssentialPlus(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PLUS,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  // useEffect(() => {
  //   const payload = {
  //     orderby: showOrderBy ? "ascending" : "descending",
  //     type: filterVal,
  //     awaitingStatus: "",
  //   };
  //   dispatch(FetchPurchasingOrderAwaiting(payload));
  // }, [dispatch, filterVal, showOrderBy, viewByTxtShow]);

  // useEffect(() => {
  //   dispatch(ApproveOrder("orderId"));
  // }, [viewByTxtShow]);

  useEffect(() => {
    if (fetchTotalStockData != null) {
      if (fetchTotalStockData?.status && fetchTotalStockData?.data) {
        let _stockData = fetchTotalStockData?.data.slice(0, 8);
        setStockData(_stockData);
      }
    }
  }, [fetchTotalStockData]);

  useEffect(() => {
    if (puchasingAdviceData != null) {
      if (puchasingAdviceData?.status && puchasingAdviceData?.data) {
        setAdvicedPurchaseData(puchasingAdviceData.data);
      }
    }
  }, [puchasingAdviceData]);

  useEffect(() => {
    if (fetchPurchasingOrderAwaitingData != null) {
      if (
        fetchPurchasingOrderAwaitingData?.status &&
        fetchPurchasingOrderAwaitingData?.data
      ) {
        setTableData(fetchPurchasingOrderAwaitingData?.data);
      }
    }
  }, [fetchPurchasingOrderAwaitingData]);

  const calculatePagination = (pageNumber) => {
    let records = tableData || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(5 * pageNumber - 4, 1),
      endRecordIndex: Math.min(5 * pageNumber, records.length),
      totalPages: Math.ceil(records.length / 5),
      records: records?.slice((pageNumber - 1) * 5, pageNumber * 5),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };

  const calculatePagination2 = (pageNumber) => {
    let records = tableData || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      // 5 की जगह 10 किया और -4 की जगह -9 किया ताकि पहला रिकॉर्ड सही इंडेक्स (जैसे 10 * 1 - 9 = 1) से शुरू हो
      startRecordIndex: Math.max(10 * pageNumber - 9, 1),
      endRecordIndex: Math.min(10 * pageNumber, records.length),
      totalPages: Math.ceil(records.length / 10),
      records: records?.slice((pageNumber - 1) * 10, pageNumber * 10),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [tableData]);

  // const filterOption = [
  //   { label: "Order ID", value: "Order ID" },
  //   { label: "Supplier", value: "Supplier" },
  //   { label: "Project", value: "Project" },
  //   { label: "Arrival Date", value: "Arrival Date" },
  // ];

  const filterOption = [
    {
      label: t("Order ID"),
      value: "Order ID",
    },
    {
      label: t("Supplier"),
      value: "Supplier",
    },
    {
      // label: FetchTranslationList[8]?.translation,
      label: t("Project"),
      value: "Project",
    },
    {
      // label: FetchTranslationList[20]?.translation,
      label: t("Arrival Date"),
      value: "Arrival Date",
    },
  ];

  const formatNumber = (number) => {
    return number ? number.toFixed(0).replace(/\d(?=(\d{3})+$)/g, "$&,") : 0;
  };

  const GenerateAdvisedPurchaseOrder = () => {
    generateAdvicedPurchaseOrder().then((o) => {
      history.push({
        pathname: "/advance-item-purchasing",
      });
    });
  };

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      ViewBy_Popup_Ref.current &&
      !ViewBy_Popup_Ref.current.contains(event.target)
    ) {
      setAwaitingDropDownShow(false);
      setArrowOptionsRotate(false);
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [viewByTxtShow, setViewByTxtShow] = useState(
    t("Purchasing Orders awaiting Delivery"),
  );

  useEffect(() => {
    // Update state when FetchTranslationList is available
    if (t("Purchasing Orders awaiting Delivery")) {
      setViewByTxtShow(t("Purchasing Orders awaiting Delivery"));
    }
  }, [FetchTranslationList]);

  const [filterShow, setFilterShow] = useState(true);
  const [awaitingDropDownShow, setAwaitingDropDownShow] = useState(false);
  const [awaitingDeliveryShow, setAwaitingDeliveryShow] = useState(true);
  const [awaitingApprovalShow, setAwaitingApprovalShow] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [poStatus, setPoStatus] = useState(
    "Purchasing Orders awaiting Delivery",
  );
  const [selectedImg, setSelectedImg] = useState(clock);
  const [selectedData, setSelectedData] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const payload = {
      orderby: showOrderBy ? "ascending" : "descending",
      type: filterVal,
      awaitingStatus: poStatus,
      querystring: query,
    };
    dispatch(FetchPurchasingOrderAwaiting(payload));
  }, [
    dispatch,
    filterVal,
    showOrderBy,
    viewByTxtShow,
    approvedOrderRes,
    query,
  ]);

  const handleAddApproved = () => {
    if (selectedData) {
      let payload = selectedData.map((x) => ({
        orderId: x.asc_PO_OrderID,
      }));
      dispatch(ApproveOrder(payload));
    }
  };

  useEffect(() => {
    if (approvedOrderRes.status === true) {
      setApprovedData(approvedOrderRes?.data);

      // if selectedData.length greater than 0.

      if (selectedData.length > 0) {
        handleGeneralNotification({
          notificationType: "CUSTOM",
          text: "All selected PO were approved and are awaiting delivery.",
        });
      }

      setSelectedData([]);
    }
  }, [approvedOrderRes]);

  const [downloadingOrderId, setDownloadingOrderId] = useState(null);

  const downloadDefaultPurchaseOrderPdf = async (order) => {
    setDownloadingOrderId(order.orderid);

    try {
      const response = await grapesTemplateApi.renderDefaultPurchaseOrderPdf(
        order.orderid,
      );
      if (!response.headers["content-type"]?.includes("application/pdf")) {
        const payload = JSON.parse(await response.data.text());
        throw new Error(
          payload?.message || "Unable to generate the default purchase order template PDF.",
        );
      }

      const objectUrl = URL.createObjectURL(response.data);
      const downloadLink = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"] || "";
      const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);

      downloadLink.href = objectUrl;
      downloadLink.download = fileNameMatch?.[1]?.replace(/["']/g, "") || `${order.ordercode}.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      let message = error?.message || "Unable to download the default purchase order template PDF.";
      if (error?.response?.data instanceof Blob) {
        try {
          const payload = JSON.parse(await error.response.data.text());
          message = payload?.message || message;
        } catch {
          // The response is not JSON, so keep the safe fallback message.
        }
      }

      handleGeneralNotification({ notificationType: "CUSTOM", text: message }, false);
    } finally {
      setDownloadingOrderId(null);
    }
  };

  return (
    <>
      {downloadingOrderId && (
        <div className="document-download-loader" role="status" aria-live="polite">
          <Loader />
          <p>Preparing PDF download...</p>
        </div>
      )}
      <AddPurchasingOrderModal isOpen={isOpen} onClose={handleClose} />
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="fw-bold Contact-heading d-flex gap-3 align-items-center">
            {/* Stock */}
            {t("Stock")}
            <img
              className="pointer"
              src={settingsIcon}
              alt=""
              onClick={() => {
                if (roleid === process.env.REACT_APP_IS_OWNER) {
                  history.push("/Stock-Authorization");
                }
              }}
            />
            <p
              className="mb-0 pointer poSettings"
              onClick={() => {
                if (roleid === process.env.REACT_APP_IS_OWNER) {
                  history.push("/Stock-Authorization");
                }
              }}
            >
              {/* PO Settings */}
              {t("PO Settings")}
            </p>
          </div>
        }
      />
      <div className="container-fluid mainWrapper ">
        <div className="row container-tablet">
          <div className="col-12 col-xl-8 stockCards">
            <div className="d-flex flex-column cards-table ">
              {screenSize === "xs" || isOrderPicking ? (
                <div className="d-flex flex-column stock-wrapper ">
                  <div
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.2rem",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </div>
                  <div className="d-flex  main-stock-card">
                    {/* {roleid !== process.env.REACT_APP_IS_VIEWER &&
                      <div
                        className="stock-card-mobile"
                        onClick={() => {
                          history.push("/add-purchasing-order");
                        }}
                      >
                        <img
                          className="purchasing-img"
                          src={ShoppingCartIcon}
                          alt="purchasing"
                        />
                        <div style={{ textAlign: 'center' }}>
                          Add <div> purchasing order</div>
                        </div>
                      </div>
                    } */}
                    <div
                      className="stock-card-mobile"
                      onClick={() => {
                        history.push("/add-to-warehouse-project");
                      }}
                    >
                      <img
                        src={WarehouseIcon}
                        className="warehouse-img"
                        alt="warehouse"
                      />
                      <div className="stock-mobile-res w-auto">
                        {/* Add to warehouse & <div> Assign to Project</div> */}
                        {t("Add to warehouse & Assign to Project").slice(0, 19)}
                        <div>
                          {t("Add to warehouse & Assign to Project").slice(19)}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex  main-stock-card">
                    <div
                      className="stock-card-mobile"
                      onClick={() => {
                        history.push("/order-picking");
                      }}
                    >
                      <img
                        src={OrderPickingInIcon}
                        className="order-picking-img"
                        alt="OrderPicking"
                      />
                      <div className="stock-mobile-res">
                        {/* Order Picking */}
                        {t("Order Picking")}
                      </div>
                    </div>
                    {/* {roleid !== process.env.REACT_APP_IS_VIEWER &&
                      <div
                        className={`${screenSize === 'xs' ? "stock-card-mobile" : "stock-card"}`}
                        onClick={() => {
                          history.push("/productsList");
                        }}
                      >
                        <img
                          src={ProductIcon}
                          className="products-img"
                          alt="Products"
                        />
                        <div style={{ textAlign: 'center' }}>Products & Parts</div>
                      </div>
                    } */}
                  </div>
                  <div className="d-flex  main-stock-card">
                    <div
                      className="stock-card-mobile"
                      onClick={() => {
                        history.push("/return-to-warehouse-single");
                      }}
                    >
                      <img
                        src={OrderPickingOutIcon}
                        className="order-picking-img"
                        alt="OrderPicking"
                      />
                      <div className="stock-mobile-res">
                        Return to Warehouse
                      </div>
                    </div>
                  </div>
                  <div className="d-flex  main-stock-card">
                    {/* {roleid !== process.env.REACT_APP_IS_VIEWER && <div
                      className={`${screenSize === 'xs' ? "stock-card-mobile" : "stock-card"}`}
                      onClick={() => {
                        history.push("/supplier-list");
                      }}
                    >
                      <img
                        src={SupplierIcon}
                        className="suppliers-img"
                        alt="Suppliers"
                      />
                      <div style={{ textAlign: 'center' }}>Suppliers</div>
                    </div>
                    } */}
                    <div
                      onClick={() => {
                        history.push("/stock-levels-single");
                      }}
                      className={`${
                        screenSize === "xs" || isOrderPicking
                          ? "stock-card-mobile"
                          : "stock-card"
                      }`}
                    >
                      <img
                        src={CountStockIcon}
                        className="count-stock-img"
                        alt="CountStock"
                      />
                      <div className="stock-mobile-res">
                        {/* Count stock */}
                        {t("Stock Levels")}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="d-fle-x d-none flex-column stock-wrapper ">
                  <div className="d-flex  main-stock-card">
                    {roleid !== process.env.REACT_APP_IS_VIEWER && (
                      <div
                        className={`${
                          screenSize === "xs" || isOrderPicking
                            ? "stock-card-mobile"
                            : "stock-card"
                        }`}
                        onClick={handleOpen}
                      >
                        <img
                          className="purchasing-img"
                          src={ShoppingCartIcon}
                          alt="purchasing"
                        />
                        <div>
                          {/* Add <div> purchasing order</div> */}
                          {t("Add purchasing order").slice(0, 3)}
                          <div>{t("Add purchasing order").slice(3)}</div>
                        </div>
                      </div>
                    )}
                    <div
                      className={`${
                        screenSize === "xs" || isOrderPicking
                          ? "stock-card-mobile"
                          : "stock-card"
                      }`}
                      onClick={() => {
                        history.push("/add-to-warehouse-project");
                      }}
                    >
                      <img
                        src={WarehouseIcon}
                        className="warehouse-img"
                        alt="warehouse"
                      />
                      <div>
                        {/* Add to warehouse & <div> Assign to Project</div> */}
                        {t("Add to warehouse & Assign to Project").slice(0, 19)}
                        <div>
                          {t("Add to warehouse & Assign to Project").slice(19)}
                        </div>
                      </div>
                    </div>
                    <div
                      className="d-flex gap-1"
                      style={{ width: "clamp(270px, 20.052vw, 20.052vw)" }}
                    >
                      <div
                        className={"stock-card-min"}
                        onClick={() => {
                          history.push("/order-picking");
                        }}
                      >
                        <img
                          src={OrderPickingInIcon}
                          className="order-picking-img"
                          alt="OrderPicking"
                        />
                        <div>
                          {/* Order Picking */}
                          {t("Order Picking")}
                        </div>
                      </div>
                      <div
                        className={"stock-card-min"}
                        onClick={() => {
                          history.push("/return-to-warehouse-single");
                        }}
                      >
                        <img
                          src={OrderPickingOutIcon}
                          className="order-picking-img"
                          alt="OrderPicking"
                        />
                        <div>
                          {/* Return to Warehouse */}
                          {t("Return to Warehouse")}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex  main-stock-card position-relative">
                    {roleid !== process.env.REACT_APP_IS_VIEWER && (
                      <div
                        className={`${
                          screenSize === "xs" || isOrderPicking
                            ? "stock-card-mobile"
                            : "stock-card"
                        }`}
                        onClick={() => {
                          history.push("/productsList");
                        }}
                      >
                        <img
                          src={ProductIcon}
                          className="products-img"
                          alt="Products"
                        />
                        <div>
                          {/* Products & Parts */}
                          {t("Products & Services")}
                        </div>
                      </div>
                    )}
                    {roleid !== process.env.REACT_APP_IS_VIEWER && (
                      <div
                        className={`${
                          screenSize === "xs" || isOrderPicking
                            ? "stock-card-mobile"
                            : "stock-card position-relative"
                        }`}
                        onClick={() => {
                          history.push("/supplier-list");
                        }}
                      >
                        <img
                          src={SupplierIcon}
                          className="suppliers-img"
                          alt="Suppliers"
                        />
                        <div>
                          {/* Suppliers */}
                          {t("Suppliers")}
                        </div>
                      </div>
                    )}
                    <div
                      onClick={() => {
                        setStockLevel(!stockLevel);
                      }}
                      className={`${
                        screenSize === "xs" || isOrderPicking
                          ? "stock-card-mobile"
                          : "stock-card"
                      }`}
                    >
                      <img
                        src={CountStockIcon}
                        className="count-stock-img"
                        alt="CountStock"
                      />
                      <div>
                        {/* Count stock */}
                        {t("Stock Levels")}
                      </div>
                    </div>
                    {stockLevel && (
                      <div className="stock-level">
                        <img
                          src={xIcon}
                          alt=""
                          onClick={() => setStockLevel(false)}
                        />
                        <div className="stock-level-sub">
                          <div
                            className="stock-level-card"
                            onClick={() => {
                              history.push("/stock-levels-single");
                            }}
                          >
                            <div className="stock-level-card-content">
                              {/* Products & Parts Stock Levels */}
                              {t("Products & Parts Stock Levels")}
                            </div>
                          </div>
                          <div
                            className="stock-level-card"
                            onClick={() => {
                              history.push("/product-stock-entry");
                            }}
                          >
                            <div className="stock-level-card-content">
                              {/* Product Stock Entry */}
                              {t("Product Stock Entry")}
                            </div>
                          </div>
                          <div
                            className="stock-level-card"
                            onClick={() => {
                              history.push("/product-stock-out");
                            }}
                          >
                            <div className="stock-level-card-content">
                              {/* Product Stock Out */}
                              {t("Product Stock Out")}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {screenSize !== "xs" && !isOrderPicking && (
                <div className="table-data">
                  <div className="d-flex gap-4 flex-wrap justify-content-between align-items-center borderTopBottom pb-3">
                    <div className="table-title-main">
                      {/* Purchasing Orders awaiting Delivery{" "} */}
                      {/* {FetchTranslationList[17]?.translation} */}

                      <div
                        ref={ViewBy_Popup_Ref}
                        className="asc_Search_Box ms- d-flex gap-2 pointer"
                        style={{
                          border: "unset",
                          background: "unset",
                          boxShadow: "unset",
                          width: "315px",
                        }}
                      >
                        <p
                          className="asc_Client_Input_For_Long d-flex"
                          onClick={() => {
                            setAwaitingDropDownShow(!awaitingDropDownShow);
                            setArrowOptionsRotate(!arrowOptionsRotate);
                          }}
                        >
                          {/* {projectName ? projectName : "Select a Project"} */}
                          <img
                            src={selectedImg}
                            alt=""
                            className="mx-2"
                            width={15}
                          />
                          <p className="mb-0">{viewByTxtShow}</p>
                        </p>

                        <img
                          src={DownArrowOption}
                          className={
                            arrowOptionsRotate
                              ? "upArrow mt-1"
                              : "downArrow mt-1"
                          }
                          alt=""
                          onClick={() => {
                            setAwaitingDropDownShow(!awaitingDropDownShow);
                            setArrowOptionsRotate(!arrowOptionsRotate);
                          }}
                        />

                        {awaitingDropDownShow && (
                          <div
                            className="asc_Custom_Select_Outer pt-3"
                            style={{
                              // borderTop: "none",
                              // border: "unset",
                              top: "50px",
                              borderRadius: "8px",
                              background: "white",
                            }}
                          >
                            <div className="">
                              <p
                                className={
                                  viewByTxtShow ===
                                  t("Purchasing Orders awaiting Delivery")
                                    ? "asc_Selected_Item d-flex mb-3 p-1"
                                    : "mb-3 hoverItem p-1"
                                }
                                style={{
                                  boxShadow: "unset",
                                }}
                                onClick={() => {
                                  setViewByTxtShow(
                                    t("Purchasing Orders awaiting Delivery"),
                                  );
                                  setAwaitingDeliveryShow(true);
                                  setFilterShow(true);
                                  setAwaitingApprovalShow(false);
                                  setAwaitingDropDownShow(false);
                                  setArrowOptionsRotate(false);
                                  setPoStatus(
                                    "Purchasing Orders awaiting Delivery",
                                  );
                                  setSelectedImg(clock);
                                }}
                              >
                                <img
                                  src={clock}
                                  alt=""
                                  className="mx-2"
                                  width={15}
                                />
                                {t("Purchasing Orders awaiting Delivery")}
                                {viewByTxtShow ===
                                  t("Purchasing Orders awaiting Delivery") && (
                                  <p className="mb-0 ps-4">✔</p>
                                )}
                              </p>

                              <p
                                className={
                                  viewByTxtShow ===
                                  "Purchasing Orders awaiting Approval"
                                    ? "asc_Selected_Item d-flex mb-3 p-1"
                                    : "hoverItem d-flex mb-3 p-1"
                                }
                                style={{
                                  boxShadow: "unset",
                                }}
                                onClick={() => {
                                  setViewByTxtShow(
                                    // "Purchasing Orders awaiting Approval"
                                    t("Purchasing Orders awaiting Approval"),
                                  );
                                  setAwaitingApprovalShow(true);
                                  setFilterShow(true);
                                  setAwaitingDeliveryShow(false);
                                  setAwaitingDropDownShow(false);
                                  setArrowOptionsRotate(false);
                                  setPoStatus(
                                    "Purchasing Orders awaiting Approval",
                                  );
                                  setSelectedImg(pin);
                                }}
                              >
                                <img
                                  src={pin}
                                  alt=""
                                  className="mx-2"
                                  width={15}
                                />
                                {/* Purchasing Orders awaiting Approval */}
                                {t("Purchasing Orders awaiting Approval")}
                                {viewByTxtShow ===
                                  t("Purchasing Orders awaiting Approval") && (
                                  <p className="mb-0 ps-4">✔</p>
                                )}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {filterShow && (
                      <div className="stock-filter">
                        <span className="stock-filter-title">
                          {/* Sort by */}
                          {t("SortBy")}
                        </span>
                        <div className="table-filter">
                          <div className="table-filter-sub">
                            <BiUpArrowAlt
                              onClick={() => setShowOrderBy(!showOrderBy)}
                              className={`${
                                showOrderBy === true
                                  ? "down-arrow down-arrow-rotate bi-paperclip "
                                  : "down-arrow bi-paperclip"
                              } table-filter-sub-icon`}
                            />
                          </div>
                          <p
                            className="margin-0 table-filter-p"
                            onClick={() => setShowFilterDrop(!showFilterDrop)}
                          >
                            {filterVal ? filterVal : "Select"}
                          </p>

                          {showFilterDrop && (
                            <div className="drop-down-stock-filter">
                              {filterOption?.map((item, i) => {
                                return (
                                  <div
                                    className={
                                      item?.label === filterVal
                                        ? " stock-list-select typ-list"
                                        : "typ-list"
                                    }
                                  >
                                    <p
                                      className={
                                        item?.label === filterVal &&
                                        " stock-list-select-p"
                                      }
                                      key={i}
                                      onClick={() => {
                                        setFilterVal(item.value);
                                        setShowFilterDrop(false);
                                      }}
                                    >
                                      {item.label}
                                    </p>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* new changes */}
                    <div className="position relative">
                      <div
                        className="px-3 py-2 pointer"
                        onClick={handleOpen}
                        style={{
                          background: "#00246a",
                          color: "white",
                          fontSize: "14px",
                          borderRadius: "10px",
                        }}
                      >
                        Add PO
                      </div>

                      {stockLevel && (
                        <div
                          style={{
                            position: "fixed",
                            inset: 0,
                            background: "#00000080",
                            zIndex: 9999,
                          }}
                        >
                          <div
                            className="stock-level"
                            // style={{ top: "200px", left: "400px" }}
                            style={{ top: "25%", left: "30%" }}
                          >
                            <img
                              src={xIcon}
                              alt=""
                              onClick={() => setStockLevel(false)}
                            />
                            <div className="stock-level-sub">
                              <div
                                className="stock-level-card"
                                onClick={() => {
                                  history.push("/stock-levels-single");
                                  localStorage.removeItem("openStockLevels");
                                }}
                              >
                                <div className="stock-level-card-content">
                                  {/* Products & Parts Stock Levels */}
                                  {t("Products & Parts Stock Levels")}
                                </div>
                              </div>
                              <div
                                className="stock-level-card"
                                onClick={() => {
                                  history.push("/product-stock-entry");
                                  localStorage.removeItem("openStockLevels");
                                }}
                              >
                                <div className="stock-level-card-content">
                                  {/* Product Stock Entry */}
                                  {t("Product Stock Entry")}
                                </div>
                              </div>
                              <div
                                className="stock-level-card"
                                onClick={() => {
                                  history.push("/product-stock-out");
                                  localStorage.removeItem("openStockLevels");
                                }}
                              >
                                <div className="stock-level-card-content">
                                  {/* Product Stock Out */}
                                  {t("Product Stock Out")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* end */}

                    <div className="stock-custom-pagination">
                      <div>
                        {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj.totalRecords}`}
                      </div>
                      <div className="pagination-buttons">
                        <div
                          className={`update-stock-pagination-button ${
                            paginationObj.currentPage === 1 ? "disabled" : ""
                          }`}
                          onClick={() =>
                            calculatePagination(paginationObj.currentPage - 1)
                          }
                        >
                          <BsChevronLeft />
                        </div>
                        <div className="pagination-current-page">
                          {paginationObj.currentPage}
                        </div>
                        <div
                          className={`update-stock-pagination-button ${
                            paginationObj.totalPages === 0 ||
                            paginationObj.totalPages ===
                              paginationObj.currentPage
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() =>
                            calculatePagination(paginationObj.currentPage + 1)
                          }
                        >
                          <BsChevronRight />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Awaiting start */}
                  {awaitingDeliveryShow && (
                    <div className="tableWrapper">
                      <table className="table stock-table">
                        <thead>
                          <tr>
                            {/* <th>Order ID</th>
                        <th>Supplier</th>
                        <th>Project</th>
                        <th></th>
                        <th>Arrival Date</th>
                        <th></th> */}

                            <th>{t("Order ID")}</th>
                            <th>
                              {/* Type */}
                              {t("Type ")}
                            </th>
                            <th>{t("Supplier")}</th>
                            <th>{t("Project")}</th>
                            <th></th>
                            <th>{t("Arrival Date")}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody className="border-0">
                          {paginationObj?.records?.map((item) => {
                            return (
                              <tr key={`tbl-row-${item.orderid}`}>
                                <td
                                  className="orderId cursor-pointer"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "orderid",
                                      item.orderid,
                                    );
                                  }}
                                >
                                  <Link
                                    to={{
                                      pathname: `/view-purchasing-order/${item.ordercode}`,
                                      state: {
                                        supplierid: item.supplierid,
                                        projectname: item.projectname,
                                        suppliername: item.suppliername,
                                      },
                                    }}
                                    className="redirect-link"
                                  >
                                    {item.ordercode}
                                  </Link>
                                </td>
                                <td>{item.type}</td>
                                <td>{item.suppliername}</td>
                                <td>{item.projectcode}</td>
                                <td>{item.projectname}</td>
                                <td>
                                  <div className="d-flex gap-3 ">
                                    <img
                                      className="calender-img"
                                      src={calender}
                                      alt="calender"
                                    />
                                    <span
                                      style={{
                                        color: moment(
                                          item.arrivaltime,
                                        ).isBefore(moment(), "day")
                                          ? "red"
                                          : "black",
                                      }}
                                    >
                                      {moment(item.arrivaltime).format(
                                        "DD.MM.YYYY",
                                      )}

                                      {/* add 8 days */}
                                      {/* {moment(item.arrivaltime)
                                        .add(8, "days")
                                        .format("DD.MM.YYYY")} */}

                                      {/* original moment object ko mutate karta hai. Agar same object kahin aur use ho raha hai to clone kar lo: */}
                                      {/* {moment(item.arrivaltime)
                                        .clone()
                                        .add(item?.leadtime?.leadtime, "days")
                                        .format("DD.MM.YYYY")} */}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <img
                                    className="pdf-img"
                                    src={pdfIcon}
                                    alt="Download purchase order PDF"
                                    style={{
                                      cursor:
                                        downloadingOrderId === item.orderid
                                          ? "wait"
                                          : "pointer",
                                      opacity:
                                        downloadingOrderId === item.orderid
                                          ? 0.55
                                          : 1,
                                    }}
                                    onClick={() => {
                                      if (downloadingOrderId !== item.orderid) {
                                        downloadDefaultPurchaseOrderPdf(item);
                                      }
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {tableData.length === 0 && (
                        <div className="nodata-found">
                          {/* No data found .. */}
                          {t("No data found ..")}
                        </div>
                      )}
                    </div>
                  )}
                  {/* Awaiting end */}

                  {/* Approval start */}
                  {awaitingApprovalShow && (
                    <div className="tableWrapper">
                      <table className="table stock-table">
                        <thead>
                          <tr>
                            {/* <th>Order ID</th>
                        <th>Supplier</th>
                        <th>Project</th>
                        <th></th>
                        <th>Arrival Date</th>
                        <th></th> */}

                            <th
                              style={{
                                width: "0%",
                              }}
                            >
                              <button
                                disabled={selectedData.length === 0}
                                className={
                                  selectedData.length === 0
                                    ? "approve"
                                    : "approveHiglight ascButton"
                                }
                                onClick={() => {
                                  handleAddApproved();
                                }}
                              >
                                {/* Approve */}
                                {t("Approve ")}
                              </button>
                            </th>
                            <th>{t("Order ID")}</th>
                            <th>{t("Supplier")}</th>
                            <th>{t("Project")}</th>
                            <th></th>
                            <th>
                              {/* Amount */}
                              {t("Amount ")}
                            </th>
                            <th>
                              {/* Owner */}
                              {t("Owner ")}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="border-0">
                          {paginationObj?.records?.map((item, index) => {
                            return (
                              <tr key={`tbl-row-${item.orderid}`}>
                                <td className="text-center pe-4">
                                  <input
                                    type="checkbox"
                                    checked={item.checked}
                                    className="form-check-input pointer companyRadio"
                                    onClick={(e) => {
                                      let index2 = selectedData.findIndex(
                                        (selected) =>
                                          selected?.asc_PO_OrderID ===
                                          item.orderid,
                                      );

                                      if (index2 !== -1) {
                                        let data = [...selectedData];
                                        data.splice(index2, 1);
                                        setSelectedData(data);
                                        return;
                                      }

                                      // start item pushing...
                                      let invoiceListArray = [...selectedData];
                                      invoiceListArray.push({
                                        asc_PO_OrderID: item.orderid,
                                        asc_PO_OrderCode: item.ordercode,
                                      });
                                      setSelectedData(invoiceListArray);
                                    }}
                                  />
                                </td>
                                <td
                                  className="orderId cursor-pointer"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "orderid",
                                      item.orderid,
                                    );
                                  }}
                                >
                                  <Link
                                    to={{
                                      pathname:
                                        item.ordertype === "Rent"
                                          ? `/view-rent-order/${item.ordercode}`
                                          : `/view-purchasing-order/${item.ordercode}`,
                                      state: {
                                        supplierid: item.supplierid,
                                        projectname: item.projectname,
                                        suppliername: item.suppliername,
                                      },
                                    }}
                                    className="redirect-link"
                                  >
                                    {item.ordercode}
                                  </Link>
                                </td>
                                <td>{item.suppliername}</td>
                                <td>{item.projectcode}</td>
                                <td>{item.projectname}</td>
                                <td>
                                  <div className="d-flex gap-3 ">
                                    {europeanFormatWithSymbol(
                                      item.amount?.includes(",")
                                        ? item.amount.replace(",", "")
                                        : item.amount,
                                    )}
                                  </div>
                                </td>
                                <td>
                                  {item?.members !== null && (
                                    <div className="d-flex gap-2">
                                      {item?.members?.imageurl ? (
                                        <img
                                          src={item?.members?.imageurl}
                                          className="stockimg"
                                          alt=""
                                        />
                                      ) : (
                                        <div className="stockimgAbbr">
                                          {item?.members?.userlastname
                                            ? item?.members?.userfirstname[0] +
                                              "" +
                                              item?.members?.userlastname[0]
                                            : item?.members?.userfirstname?.slice(
                                                0,
                                                2,
                                              )}
                                        </div>
                                      )}
                                      <p className="mb-0">
                                        {item?.members?.userfirstname}{" "}
                                        {item?.members?.userlastname}
                                      </p>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {tableData.length === 0 && (
                        <div className="nodata-found">No data found ..</div>
                      )}
                    </div>
                  )}
                  {/* Approval end */}
                </div>
              )}
            </div>
          </div>

          {screenSize !== "xs" && !isOrderPicking && (
            <div className="col-12 col-xl-4 mb-3">
              <TotalStockAvailableCard
                displayQuantity={
                  packageId === process.env.REACT_APP_IS_PLUS ? 20 : 8
                }
                displayLabel={t("Total Stock Available")}
              />
              {isOwnerOrManagerOrUser && isEssentialPlus && (
                <AdvisedItemPurchaseCard
                  showActions={isNotRole(ROLES.VIEWER)}
                />
              )}
              {isOwnerOrManagerOrUser && isBuildingBlock && (
                <JustIntimePurchaseCard showActions={isNotRole(ROLES.VIEWER)} />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Stock;
